export default function More() {
  return (
    <svg
      width="72"
      height="28"
      viewBox="0 0 72 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1L35.7482 27L71 1" stroke="inherit" strokeWidth="1.5" />
    </svg>
  );
}
